import React, { ChangeEvent, useState, FormEvent, useEffect } from "react";
import { debounce } from "lodash";
import { useDispatch } from "react-redux";

import SearchSVG from "../../../assets/Icons/SearchInput";
import DropdownSearchList from "./DropdownSearchList";
import {
  useFilterProjectSelector,
  useSearchLocationSelector,
  useSearchSelector,
  useSelectedProjectSelector,
} from "../../../store/projects/selectors";

import {
  // fetchCurrentProjects,
  // fetchRecommendationProjects,
  // fetchSavedProjects,
  searchAsync,
} from "../store-utils";

import { TSuggestions } from "../../../types";
import Input from "../../../components/Input";
import { changeSearchLocationAction, loadProjectsSpecific } from "../../../store/projects/actions";

interface SearchInputProps {
  className?: string;
}

const SelectLocationInput = ({ className }: SearchInputProps) => {
  const selected = useSelectedProjectSelector();
  const dispatch = useDispatch();
  const filters = useFilterProjectSelector();

  const location = useSearchLocationSelector();
  const search = useSearchSelector();

  const [value, setValue] = useState<any>(location?.name || "");
  const [showDropDown, setShowDropDown] = useState(false);
  // const dispatch = useAppDispatch();

  // const searchedValueFromStorage: string | null = search;

  const [searchedData, setSearchedData] = useState<TSuggestions>({ suggestions: [] });

  const { suggestions } = searchedData ?? { suggestions: [] };

  useEffect(() => {
    if (!location) {
      setValue("");
    }
  }, [filters, location]);

  useEffect(() => {
    updateSearchValue(value);
  }, [value]);

  useEffect(() => {
    dispatch(loadProjectsSpecific.submit());
  }, [search]);

  const updateSearchValue = React.useCallback(
    debounce((str) => {
      if (str.trim() !== "") {
        if (selected === "recommendation") {
          searchAsync(`${str}?include_only=IND&include_only=LKA`).then((data) =>
            setSearchedData(data),
          );
        } else {
          searchAsync(str).then((data) => setSearchedData(data));
        }
        // dispatch(searchAsync(str));
        // localStorage.setItem("searchedValue", str);
      }
    }, 250),
    [],
  );

  const onChangeInput = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    if (value.length) {
      setValue(event.target.value);
      setShowDropDown(true);
    } else {
      setValue("");
      dispatch(changeSearchLocationAction(null));
    }
  };

  const handleInputFocus = () => {
    setShowDropDown(true);
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (searchedData && searchedData.suggestions && searchedData.suggestions.length > 0) {
      // projectsDisplayed === "Current"
      //     ? dispatch(searchCarbonProjectAsync(searchedData))
      //     : dispatch(searchRecommendationsAsync(searchedData));
      setShowDropDown(false);
    } else {
      setShowDropDown(true);
    }
  };

  return (
    <div className="relative">
      <form
        onSubmit={(e) => handleSubmit(e)}
        className="flex items-center justify-center md:pt-0"
        autoComplete="off"
      >
        <div className={`relative flex h-8 w-[350px] ${className ? className : ""}`}>
          <Input
            variant="outlined"
            type="search"
            id="default-search"
            className="block w-full gap-4 rounded-md  p-2 text-sm text-gray-900 "
            label={"Search by location"}
            value={value}
            onChange={onChangeInput}
            onFocus={handleInputFocus}
          ></Input>
          {/* <input
            type="search"
            id="default-search"
            className="block w-full gap-4 rounded-md border border-gray-300 p-2 text-sm text-gray-900 ring-black hover:ring-1 focus:ring-1"
            placeholder={"Search by location"}
            value={value}
            onChange={onChangeInput}
            onFocus={handleInputFocus}
            required
          /> */}
          <button type="submit" className="absolute bottom-5 right-12 cursor-pointer">
            <div className="absolute inset-y-0 start-0 flex items-center ps-3">
              {value ? null : <SearchSVG stroke={"black"} />}
            </div>
          </button>
        </div>
      </form>
      {showDropDown && searchedData && suggestions.length !== 0 && (
        <DropdownSearchList
          searchedData={searchedData}
          setInputValue={setValue}
          setShowDropDown={setShowDropDown}
        />
      )}
    </div>
  );
};

export default SelectLocationInput;
